import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { ChatCircleDots } from "@phosphor-icons/react";

export default function AdminFeedback() {
    const [items, setItems] = useState([]);
    useEffect(() => {
        (async () => {
            try { const { data } = await api.get("/admin/feedback"); setItems(data.items); }
            catch { /* endpoint returns empty list until feedback ingest is built */ }
        })();
    }, []);

    if (items.length === 0) {
        return (
            <div className="max-w-2xl mx-auto bg-white border-2 border-dashed border-[#BFD3FF] rounded-2xl p-10 text-center">
                <ChatCircleDots size={44} weight="duotone" className="text-[#1E3A8A] mx-auto mb-3" />
                <h3 className="font-heading font-bold text-xl">Feedback inbox is empty</h3>
                <p className="text-slate-500 mt-2 text-sm">
                    Once you add a feedback form or in-app report widget, submissions will appear here for triage.
                </p>
                <div className="mt-4 text-[10px] uppercase tracking-widest text-slate-400">Backend endpoint ready: GET /api/admin/feedback</div>
            </div>
        );
    }

    return (
        <div className="space-y-3">
            {items.map((f, i) => (
                <div key={i} className="bg-white border-2 border-[#BFD3FF] rounded-2xl p-4">
                    <div className="text-xs text-slate-500">{f.created_at}</div>
                    <div className="text-sm mt-1">{f.message}</div>
                </div>
            ))}
        </div>
    );
}
